import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Paragraph } from '../Typography'

const useStyles = makeStyles(theme => ({
    root: {
        padding: `${ theme.spacing(8) }px ${ theme.spacing(4) }px`,
        marginLeft: '6rem',
    }
}))

export const Footer = props => {
    const classes = useStyles()

    return (
        <footer className={ classes.root }>
            <Paragraph>
                This application is developed by <a href="https://renci.org/" target="_blank" rel="noopener noreferrer">Renaissance Computing Institute</a>.
            </Paragraph>
        </footer>
    )
}
